import { storyblokEditable } from "@storyblok/react";
import React, { useRef, useEffect, useState } from "react";
import Head from "next/head";
import Script from "next/script";
import dynamic from "next/dynamic";

function Schankdruckrechner({ blok }) {
  const [iframeHeight, setIframeHeight] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  /* function setIframe(){
    var iframe = document.getElementById('iframe')
    iframe.style.font = "menu !important";
  }

  useEffect(() => {
    setIframe(); 
  }, []) */
  

 

  return (
    <div className="schankdruckrechner-wrap wrap">
    <div className="schankdruckrechner--main">
      <div className="schankdruckrechner--container--teaser">
        <div>
          {/* <h2 className="schankdruckrechner--container--teaser--headline text-3xl">
            Schankdruckrechner
          </h2> */}
        {/*   <p className="schankdruckrechner--container--teaser--description">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum
            minima natus porro? Voluptas sunt odio voluptates deserunt veritatis
            a adipisci eius neque, ratione maxime reprehenderit quae sapiente
            temporibus voluptatum dolor? Lorem ipsum dolor sit, amet consectetur
            adipisicing elit. Odio debitis ratione exercitationem, quidem, unde
            error laudantium doloribus obcaecati et, explicabo non dolor
            accusamus dolorum. Dolore molestiae perspiciatis corrupti voluptas
            sapiente? Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Nesciunt enim, eos voluptates delectus quas quis aut expedita
            dolorem hic quam magni, tenetur aliquam voluptatibus. Dolor
            repudiandae incidunt at dolore magnam?
          </p> */}
        </div>
        <div className="iframe-box">
          <iframe 
            id="iframe"
            src="/schankdruckrechner.html"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Schankdruckrechner;
